const PaymentMethodOptions = [
  { value: 'Check', label: 'Check' },
  { value: 'DirDep', label: 'Dir. Dep.' },
  { value: 'MoneyOrder', label: 'Money Order' },
  { value: 'CompanyCheck', label: 'Company Chk' },
  { value: 'Cash', label: 'Cash' },
  { value: 'PersonalCheck', label: 'Personal Chk' },
  { value: 'WireTransfer', label: 'Wire Transfer' },
  { value: 'CreditCard', label: 'Credit Card' },
  { value: 'Stripe', label: 'Stripe' },
  { value: 'BadDebt', label: 'Bad Debt' },
];

export default PaymentMethodOptions;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/arapPaymentOptions.js